var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoudspeaker28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.405 3.9c1.24-.532 2.64-.124 3.074 1.153.508 1.496 1.024 3.89 1.024 7.447 0 3.562-.518 6.088-1.026 7.71-.433 1.38-1.938 1.877-3.267 1.307l-6.388-2.738a3 3 0 0 1-1.819-2.757V9.478a3 3 0 0 1 1.819-2.757l6.583-2.822ZM1.258 13a5 5 0 0 1 5-5H9.61c.769 0 1.392.623 1.392 1.392v6.492c0 1.108.036 2.013.331 3.114l1.347 5.026a1.5 1.5 0 0 1-1.06 1.837c-2.166.58-3.143.443-3.72-1.708l-1.35-5.042c-.176-.656-.778-1.088-1.438-1.243A5.002 5.002 0 0 1 1.258 13Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoudspeaker28);
export default __webpack_public_path__ + "static/media/loudspeaker_28.d7df3a5a.svg";
export { ForwardRef as ReactComponent };